import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brS = createBreakpoint('s');

const panelsBg = (version) => version === 2
  ? { backgroundColor: '#FFF' }
  : {
    backgroundColor: '#d8dbdf',
    [brS]: {
      backgroundColor: '#f0f2f5',
    },
  };

const panelsCls = (panels) => {
  const classes = {};
  Object.keys(panels).forEach((panel, n) => classes[`&--${n}pos`] = { transform: 'translateX(100%)' });
  return classes;
}

export const mainCls = 'mp-mdl';

export default {
  [`${mainCls}`]: ({ panels, version }) => ({
    '&__panel': {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 4,
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      ...panelsBg(version),
      transform: 'translateX(0)',
      ...panelsCls(panels),
    },
  }),
};
